module.exports = __webpack_public_path__ + "static/media/u1F928.2e9ed450.webp";